import Vue from "vue";
import { graphGet } from "@/helpers/api/apiGraph";
import DriveItem from "@/models/Documents/DriveItem";
import GraphHelper from "@/helpers/utilities/GraphHelper";
import FileHelper from "@/helpers/utilities/FileHelper";

export const myFiles_state = {
  oneDriveRootState: null,
  driveItemsSharedWithMeState: null
};

export const myFiles_actions = {
  async loadMyOneDrive() {
    if (!this.oneDriveRootState) {
      await this.reloadMyOneDrive();
    }

    return this.oneDriveRootState;
  },

  async reloadMyOneDrive() {
    const response = await graphGet("/me/drive/root?$expand=children");
    const driveItem = new DriveItem(response);

    driveItem.nctSystem = "onedrive";
    driveItem.nctGroup = "onedrive";
    driveItem.nctType = "onedrive";
    driveItem.nctIdentifier = "onedrive";
    driveItem.nctBehavior = "onedrive";

    driveItem.childrenList.forEach(child => {
      child.nctSystem = "onedrive";
      child.nctGroup = "onedrive";
      child.nctType = "onedrive";
      child.nctIdentifier = "onedrive";
      child.nctBehavior = "onedrive";
    });

    this.oneDriveRootState = driveItem;

    if (!this.driveMap[driveItem.parentReference.driveId]) {
      Vue.set(this.driveMap, driveItem.parentReference.driveId, {});
    }
    Vue.set(this.driveMap[driveItem.parentReference.driveId], driveItem.id, driveItem);
    return driveItem;
  },

  async loadDriveItemsSharedWithMe() {
    const itemsSharedWithMe = await graphGet(`/me/insights/shared`);
    const sharedItemIdsToExpand = itemsSharedWithMe.value
      .filter(s => s.resourceReference?.type === "microsoft.graph.driveItem")
      .map(s => s.resourceReference.id);
    const okResponses = await loadSharedResourcesBatch(sharedItemIdsToExpand);
    const driveItemsSharedWithMe = okResponses.map(r => {
      const newDoc = new DriveItem(r.body);
      newDoc.remoteItem = new DriveItem(newDoc);
      const sharedByUser = itemsSharedWithMe.value.find(swm => swm.id === r.id)?.lastShared?.sharedBy;
      if (sharedByUser?.id) {
        newDoc.remoteItem.shared = {
          sharedBy: {
            user: sharedByUser
          }
        };
      }
      return newDoc;
    });

    await this.loadHiddenDriveItems();

    const filteredList = driveItemsSharedWithMe.filter(
      c => !this.hiddenSharedFiles?.some(h => c.id === h.itemId && c.parentReference.driveId === h.driveId)
    );

    this.driveItemsSharedWithMeState = FileHelper.addExtensionsToArrayOfFiles(filteredList);
  }
};

export const myFiles_getters = {
  oneDriveRoot: state => state.oneDriveRootState,
  driveItemsSharedWithMe: state => state.driveItemsSharedWithMeState
};

/**
 * @param idsToLoad
 */
async function loadSharedResourcesBatch(idsToLoad) {
  const expandBatchRequests = idsToLoad.map(id => ({
    id,
    method: "GET",
    url: `${id}`
  }));
  const response = await GraphHelper.makeBatchRequest(expandBatchRequests);
  const okResponses = response.filter(r => r.status === 200);
  const busyResponseIds = response.filter(r => r.status === 429).map(r => r.id);
  if (busyResponseIds.length > 0) {
    // Retry after delay
    await new Promise(resolve => setTimeout(resolve, 6000));
    const retryResponses = await loadSharedResourcesBatch(busyResponseIds);
    okResponses.push(...retryResponses);
  }
  return okResponses;
}
